<template>
  <div>
    <div class="content-grid mdl-grid mdl-grid--no-spacing center-items">
      <!-- <div class="mdl-layout-spacer"></div> -->
        <div class="mdl-cell mdl-cell--6-col mdl-card mdl-shadow--6dp" v-if="$store.state.billsData" v-for="bill in $store.state.billsData.bills">
          <header class="mdl-card__title mdl-card--border">
            <span class="mdl-card__title-text">
                <span>{{ `Vechile No: ${bill.vehiclenumber || 'Not Available'}` }}</span>
            </span>
            <div class="mdl-layout-spacer"></div>
            <pre> {{ `Bill No: ` }}{{ bill.sequenceNumber | formatSequenceNumber }}</pre>
          </header>
          <div class="mdl-cell mdl-cell--12-col mdl-card__supporting-text">
                <div><strong>Email:</strong> {{ bill.emailaddress || 'Not Available'}}</div>
                <div><strong>Name: </strong>{{ bill.firstname }} {{ bill.lastname }}</div>
                <div><strong>Amount:</strong> {{ bill.amount || 'Not Available'}}</div>
                <div><strong>Date:</strong> {{ bill.timestamp | formatDate }}</div>
          </div>
          <div class="mdl-grid mdl-card__actions mdl-card--border">
              <!-- <router-link
                v-mdl
                class="mdl-cell mdl-cell--12-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
                v-bind:to="{ name: 'view-bill', params: { bill: bill.id, company: $store.state.userData.user.company }}">
                View Bill
              </router-link> -->
              <button v-mdl @click="setBillValue(bill.id)"
                class="mdl-color-text--blue-grey-900 mdl-card--border mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">
                View Bill
              </button>
              <!-- <router-link v-mdl class="mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
               v-bind:to="{ name: 'home'}">Back</router-link> -->
          </div>
        </div>
      <!-- <div class="mdl-layout-spacer"></div> -->
    </div>
    <router-link id="action-button"
      class="add-picture-button mdl-button mdl-js-button mdl-button--fab mdl-button--colored mdl-shadow--16dp"
      to="/add">
      <i class="material-icons">add</i>
    </router-link>
  </div>
</template>
<script>
  // import {MyApp} from '../main.js'
  // require('material-design-lite')
  export default {
    name: 'home',
    data () {
      return {
      }
    },
    firestore:
     function () {
       // return {
       //   // user: dbinstance.collection('users').doc(firebase.auth().currentUser.uid),
       //   bills: db.collection('companies/' + this.info.user.company + '/bills').orderBy('timestamp')
       // }
     },
    created () {
      this.$nextTick(() => {
        window.componentHandler.upgradeDom()
        window.componentHandler.upgradeAllRegistered()
      })
    },
    methods: {
      setBillValue (id) {
        this.$store.state.newBillState = this.$store.state.billsData.bills[id]
        const company = this.$store.state.userData.user.company
        this.$router.push({ name: 'view-bill', params: { bill: id, company: company } })
      }
    }
  }
</script>
<style scoped>
  /* .add-picture-button {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 998;
  }
  .image-card {
    position: relative;
    margin-bottom: 8px;
  }
  .image-card__picture > img {
    width:100%;
  }
  .image-card__comment {
    position: absolute;
    bottom: 0;
    height: 52px;
    padding: 16px;
    text-align: right;
    background: rgba(0, 0, 0, 0.5);
  }
  .image-card__comment > span {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  } */
  .mdl-card{
    /* margin-bottom: 10px; */
  }
  #action-button {
    position: fixed;
    display: block;
    right: 0;
    bottom: 0;
    margin-right: 40px;
    margin-bottom: 40px;
    z-index: 900;
  }
  .mdl-grid{
    margin: 8px;
  }
  .mdl-grid.mdl-grid--no-spacing>.mdl-cell {
    margin: 8px;
  }
  pre{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeView.vue